
import { mapGetters } from 'vuex'
import PlanNotesPlanPicker from '~/components/plan-notes/PlanNotesPlanPicker.vue'
import { baseCarrierName } from '~/util/plan-name'
import { copyNotePayload, planDisplayName } from '~/util/plan-notes'

// Copy one pinned note to a plan by hand, for the gaps the yearly carry-over
// (the oracle-spa dashboard's hand-pasted query) leaves: a next-year plan
// with no previous_year link, or a note added after the query ran. Always a
// new note; the original keeps its plan.
export default {
    components: { PlanNotesPlanPicker },
    props: {
        value: { type: Boolean, default: false },
        // A pinned note from the search, with `plan` and `carry_over`.
        note: { type: Object, default: null },
    },
    data () {
        return { suggested: null, picked: null, targetYear: null, carrierName: null, saving: false }
    },
    computed: {
        ...mapGetters(['years']),
        yearOptions () { return [...this.years].sort().map(year => ({ value: year, text: year })) },
        target () { return this.suggested || this.picked },
    },
    watch: {
        value: { immediate: true, handler (open) { if (open) { this.reset() } } },
    },
    methods: {
        planName: planDisplayName,
        reset () {
            const plan = this.note?.plan
            const carry = this.note?.carry_over
            this.suggested = carry && ['missing', 'differs'].includes(carry.status) ? carry.next_plan : null
            this.picked = null
            this.saving = false
            const nextYear = plan ? plan.year + 1 : null
            this.targetYear = plan ? (this.years.includes(nextYear) ? nextYear : plan.year) : null
            this.carrierName = plan ? baseCarrierName(plan.carrier) : null
        },
        pick ({ plan }) {
            this.picked = plan
        },
        async copyNote () {
            this.saving = true
            const resp = await this.$try('createPlanNote', copyNotePayload(this.note, this.target.id))
            this.saving = false
            if (resp?.error) { return }
            this.$emit('copied', resp)
            this.$emit('input', false)
        },
    },
}
